<template>
	<div style="padding-top: 20px">
		<div class="onboarding-banner">
			<span v-if="bages.lastCenterOnboardingDaysAgo !== null">
				Last centre onboarding {{ bages.lastCenterOnboardingDaysAgo }} days ago
			</span>
			<span v-else>
				No centre onboarded yet
			</span>
		</div>
		<div class="container">
			<div class="row">
				<div class="col-12">

					<div style="margin: auto;">
						<div style="font-size: 20px; text-align: center;" class="alert"
							:class="{ 'alert-danger': n.is_important == 'y', 'alert-info': n.is_important == 'n' }"
							v-for="n in notifications" :key="n">
							<div style="float: right; cursor: pointer; font-weight: bold;"
								class="btn btn-primary btn-sm" @click="seeNotification(n)">OK</div>
							{{ n.message }}
						</div>
					</div>

				</div>
			</div>
		</div>
		<div style="height: 20px;"></div>
		<h4>Case Details</h4>
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-6 col-lg-3">
					<div class="card text-white bg-info">
						<div class="card-body">
							<div class="text-value">{{ bages.case_today }}</div>
							<div>Number of case today</div>
						</div>
					</div>
				</div>
				<div class="col-sm-6 col-lg-3">
					<div class="card text-white bg-primary">
						<div class="card-body">
							<div class="text-value">{{ bages.case_this_month }}</div>
							<div>Number of case this month</div>
						</div>
					</div>
				</div>
				<div class="col-sm-6 col-lg-3">
					<div class="card text-white bg-warning">
						<div class="card-body">
							<div class="text-value">{{ bages.case_last_month }}</div>
							<div>Number of case last month</div>
						</div>
					</div>
				</div>
				<div class="col-sm-6 col-lg-3">
					<div class="card text-white bg-danger">
						<div class="card-body">
							<div class="text-value">{{ bages.case_all_total }}</div>
							<div>Number of case all total</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div style="height: 20px;"></div>
		<h4>Commission Details</h4>
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-6 col-lg-3">
					<div class="card text-white bg-info">
						<div class="card-body">
							<div class="text-value">{{ bages.commission_today }}</div>
							<div>Commission today</div>
						</div>
					</div>
				</div>
				<div class="col-sm-6 col-lg-3">
					<div class="card text-white bg-primary">
						<div class="card-body">
							<div class="text-value">{{ bages.commission_this_month }}</div>
							<div>Commission this month</div>
						</div>
					</div>
				</div>
				<div class="col-sm-6 col-lg-3">
					<div class="card text-white bg-warning">
						<div class="card-body">
							<div class="text-value">{{ bages.commission_last_month }}</div>
							<div>Commission last month</div>
						</div>
					</div>
				</div>
				<div class="col-sm-6 col-lg-3">
					<div class="card text-white bg-danger">
						<div class="card-body">
							<div class="text-value">{{ bages.commission_all_total }}</div>
							<div>Commission all total</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div style="height: 20px;"></div>
		<h4>Center Details</h4>
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-6 col-lg-3">
					<div class="card text-white bg-info">
						<div class="card-body">
							<div class="text-value">{{ bages.center_today }}</div>
							<div>New center today</div>
						</div>
					</div>
				</div>
				<div class="col-sm-6 col-lg-3">
					<div class="card text-white bg-primary">
						<div class="card-body">
							<div class="text-value">{{ bages.center_this_month }}</div>
							<div>New center this month</div>
						</div>
					</div>
				</div>
				<div class="col-sm-6 col-lg-3">
					<div class="card text-white bg-warning">
						<div class="card-body">
							<div class="text-value">{{ bages.center_last_month }}</div>
							<div>New center last month</div>
						</div>
					</div>
				</div>
				<div class="col-sm-6 col-lg-3">
					<div class="card text-white bg-danger">
						<div class="card-body">
							<div class="text-value">{{ bages.center_all_total }}</div>
							<div>New center all total</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="container-fluid" style="padding-top: 15px;">
			<div class="row">
				<div class="col-lg-4 col-md-12" style="margin-bottom: 15px;">
					<div class="card">
						<div class="card-body">
							<div class="chart-title">Last 12 Month Business Amount</div>
							<canvas ref="businessChartRef"></canvas>
						</div>
					</div>
				</div>
				<div class="col-lg-4 col-md-12" style="margin-bottom: 15px;">
					<div class="card">
						<div class="card-body">
							<div class="chart-title">Last 12 Month Case Uploades</div>
							<canvas ref="uploadsChartRef"></canvas>
						</div>
					</div>
				</div>
				<div class="col-lg-4 col-md-12" style="margin-bottom: 15px;">
					<div class="card">
						<div class="card-body">
							<div class="chart-title">Last 12 Month Centre Added</div>
							<canvas ref="centersChartRef"></canvas>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			bages: {},
			notifications: [],
			isMounted: false,
			businessChart: null,
			uploadsChart: null,
			centersChart: null,
		}
	},
	async created() {
		this.bages = await this.get("agent/dashboard-bages");
		if (this.isMounted) {
			this.renderCharts();
		}
	},
	async mounted(){
		this.isMounted = true;
		if (this.bages && Object.keys(this.bages).length) {
			this.renderCharts();
		}
		this.notifications = await this.get('agent/load-unseen-notifications');
	},
	beforeUnmount() {
		this.destroyCharts();
	},
	methods:{
		destroyCharts() {
			if (this.businessChart) {
				try { this.businessChart.destroy(); } catch (err) { void err; }
				this.businessChart = null;
			}
			if (this.uploadsChart) {
				try { this.uploadsChart.destroy(); } catch (err) { void err; }
				this.uploadsChart = null;
			}
			if (this.centersChart) {
				try { this.centersChart.destroy(); } catch (err) { void err; }
				this.centersChart = null;
			}
		},
		renderCharts() {
			if (!this.isMounted || !window.Chart) return;
			if (!this.$refs.businessChartRef || !this.$refs.uploadsChartRef || !this.$refs.centersChartRef) return;

			let labels = Array.isArray(this.bages.last12MonthLabels) ? this.bages.last12MonthLabels : [];
			let businessAmount = Array.isArray(this.bages.last12MonthBusinessAmount) ? this.bages.last12MonthBusinessAmount : [];
			let caseUploads = Array.isArray(this.bages.last12MonthCaseUploads) ? this.bages.last12MonthCaseUploads : [];
			let centersAdded = Array.isArray(this.bages.last12MonthCentersAdded) ? this.bages.last12MonthCentersAdded : [];

			this.businessChart = this.upsertBarChart(this.businessChart, this.$refs.businessChartRef, labels, businessAmount, true);
			this.uploadsChart = this.upsertBarChart(this.uploadsChart, this.$refs.uploadsChartRef, labels, caseUploads, false);
			this.centersChart = this.upsertBarChart(this.centersChart, this.$refs.centersChartRef, labels, centersAdded, false);
		},
		upsertBarChart(existingChart, canvas, labels, values, isCurrency) {
			let monthColors = this.getMonthBarColors(labels);

			if (existingChart) {
				existingChart.data.labels = labels;
				existingChart.data.datasets[0].data = values;
				existingChart.data.datasets[0].backgroundColor = monthColors.backgroundColor;
				existingChart.data.datasets[0].borderColor = monthColors.borderColor;
				existingChart.update();
				return existingChart;
			}

			return new window.Chart(canvas, {
				type: "bar",
				data: {
					labels: labels,
					datasets: [{
						backgroundColor: monthColors.backgroundColor,
						borderColor: monthColors.borderColor,
						borderWidth: 1,
						data: values,
					}],
				},
				options: {
					animation: {
						duration: 0
					},
					legend: { display: false },
					tooltips: {
						callbacks: {
							label: (tooltipItem) => {
								let value = Number(tooltipItem.yLabel || 0);
								if (isCurrency) return "₹" + value.toLocaleString("en-IN");
								return value.toLocaleString("en-IN");
							}
						}
					},
					scales: {
						xAxes: [{
							ticks: {
								autoSkip: false,
								maxRotation: 45,
								minRotation: 45,
							}
						}],
						yAxes: [{
							ticks: {
								beginAtZero: true,
								callback: (value) => {
									let n = Number(value || 0);
									if (isCurrency) return "₹" + n.toLocaleString("en-IN");
									return n.toLocaleString("en-IN");
								}
							}
						}]
					}
				}
			});
		},
		getMonthBarColors(labels) {
			let palette = {
				jan: { bg: "#4e79a7", border: "#3f6287" },
				feb: { bg: "#f28e2b", border: "#c77424" },
				mar: { bg: "#e15759", border: "#b84749" },
				apr: { bg: "#76b7b2", border: "#60928e" },
				may: { bg: "#59a14f", border: "#488440" },
				jun: { bg: "#edc948", border: "#bfa139" },
				jul: { bg: "#b07aa1", border: "#8d6281" },
				aug: { bg: "#ff9da7", border: "#cc7e86" },
				sep: { bg: "#9c755f", border: "#7d5e4d" },
				oct: { bg: "#bab0ab", border: "#958d89" },
				nov: { bg: "#86bc86", border: "#6b966b" },
				dec: { bg: "#5f9ed1", border: "#4c7ea7" },
			};
			let fallback = { bg: "#0d6efd", border: "#0b5ed7" };

			let backgroundColor = [];
			let borderColor = [];
			(labels || []).forEach((label) => {
				let key = this.getMonthKeyFromLabel(label);
				let color = palette[key] || fallback;
				backgroundColor.push(color.bg);
				borderColor.push(color.border);
			});

			return { backgroundColor, borderColor };
		},
		getMonthKeyFromLabel(label) {
			let text = String(label || "").trim().toLowerCase();
			if (!text) return "";

			let token = text.split(/[\s/-]+/)[0] || "";
			let map = {
				jan: "jan", january: "jan",
				feb: "feb", february: "feb",
				mar: "mar", march: "mar",
				apr: "apr", april: "apr",
				may: "may",
				jun: "jun", june: "jun",
				jul: "jul", july: "jul",
				aug: "aug", august: "aug",
				sep: "sep", sept: "sep", september: "sep",
				oct: "oct", october: "oct",
				nov: "nov", november: "nov",
				dec: "dec", december: "dec",
			};
			if (map[token]) return map[token];

			let firstWordMatch = text.match(/[a-z]+/);
			if (firstWordMatch && map[firstWordMatch[0]]) return map[firstWordMatch[0]];
			return "";
		},
		async seeNotification(n) {
			let i = this.notifications.indexOf(n);
			this.notifications.splice(i, 1);
			await this.post('agent/see-notification', {
				id: n.id
			});
		},
	}
}
</script>
<style scoped>
.card-body {
	flex: 1 1 auto;
	padding: 1.25rem;
}

.text-value {
	font-size: 1.3125rem;
	font-weight: 600;
}
h4 {
	padding-left: 15px;
	font-weight: bold;
	color: #454545;
}
.chart-title {
	text-align: center;
	font-weight: bold;
	padding-bottom: 10px;
	color: #454545;
}
.onboarding-banner {
	text-align: center;
	font-size: 22px;
	font-weight: 700;
	color: #5c3a00;
	background: #fff7db;
	border: 1px solid #f2d792;
	border-radius: 10px;
	padding: 12px 16px;
	max-width: 760px;
	margin: 0 auto 12px;
}
</style>
